// extracted by mini-css-extract-plugin
module.exports = {"product-link-button":"ProductList_product-link-button__lPfUX","products-container":"ProductList_products-container__D8Xbd"};